import { render } from "./ProductSelectionBrandsSelectionItem.vue?vue&type=template&id=1a4de5f0&scoped=true&ts=true"
import script from "./ProductSelectionBrandsSelectionItem.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionBrandsSelectionItem.vue?vue&type=script&lang=ts"

import "./ProductSelectionBrandsSelectionItem.vue?vue&type=style&index=0&id=1a4de5f0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4de5f0"]])

export default __exports__